<template>
    <div class="field-item-link">
        <el-dialog
            title="关联数据"
            :width="searchFieldList.length>0?'95%':'80%'"
            custom-class="field-item-link-pop"
            append-to-body
            top="4vh"
            :visible.sync="isShowLink"
            @close="hideDialog">
            <el-button style="text-align: left;margin-top:-15px;" icon="el-icon-search" type="primary" @click="handleFilterCondition()">筛选条件</el-button>
            <el-button style="text-align: left;margin-top:-15px;" icon="el-icon-circle-plus" type="primary" @click="addNewLinkData()">新增数据</el-button>
            <el-tooltip v-if=" taskInstance && taskInstance.processInstanceId " class="item" effect="light" content="任务内表单，默认显示主子流程内的数据。去掉打钩，显示所有数据。" placement="top">
                <el-checkbox class="checkBox-style" v-model="isShowProcessData" @change="handleAllLinkData"><el-tag size="mini">流程内数据</el-tag></el-checkbox>
            </el-tooltip>
            <div  :class="searchFieldList.length>0?'form-data-box':''">
              <div class="content-tree" v-if="isCollapseForInit&&searchFieldList.length>0">
                  <el-tree
                      highlight-current
                      node-key="key"
                      @node-click="handleTreeNode"
                      :current-node-key="selectNodeId"
                      :default-expanded-keys="idSearchExpandedArr"
                      :expand-on-click-node="false"
                      :data="searchTreeData"
                  >
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span v-if="data.children && data.children.length>0">
                          <i class="icon-other-zuzhiqunzu iconfont" style="color:#1296db;font-size:16px;"></i>&nbsp;{{ data.label }}
                      </span>
                      <span v-else>
                        &nbsp;{{ data.label }}
                      </span>
                  </span>
                  </el-tree>
                  <div v-if="searchFieldList.length>0" class="left-icon">
                      <el-dropdown trigger="click"  @command="handleCommand">
                          <span class="el-dropdown-link">
                              <i class="el-icon-connection" style="color:#1296db;font-size:16px;cursor:pointer;" title="切换字段"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item v-for="(item,index) in searchFieldList"  :key="index" :command="item.id">{{item.name}}</el-dropdown-item>
                          </el-dropdown-menu>
                      </el-dropdown>
                  </div>
                </div>
                <DynamicTable
                    ref="dynamicTable"
                    v-if="isShowLink"
                    :key="loadTimer"
                    :isShowOverflowTooltip="true"
                    :isShowPageSizes="true"
                    :tableColumns="tableColumns"
                    :tableHeight="tableHeight"
                    :subformTableColumns="subformTableColumns"
                    :tableData="tableData"
                    :autoHeight="autoHeight"
                    :pager="page"
                    :hiddenPage="hiddenPage"
                    :isSortable="true"
                    :isSubform="isSubform"
                    :isColumnDrop="true"
                    :fieldsList="fieldsList"
                    :subformFieldsList="subformFieldsList"
                    :dtStyle="searchFieldList.length>0?'width: 80vw':'width: 100vw'"
                    @rowClick="handelSelectRow"
                    @changePage="queryFormData"
                    @changePageSize="queryFormDataByPageSize"
                  />
              </div>
        </el-dialog>
        <el-row>
          <el-col :span="8" >
              <el-button  v-if="!isRead" @click="getModuleData">选择关联</el-button>
              <el-button  v-if="!isRead" @click="clearModuleData" type="danger" plain>清空</el-button>
              <el-button  v-if="isShowSelectData"  @click="viewModuleData" type="private" plain>查看</el-button>
              <el-button  v-if="isShowEditData"  @click="editModuleData" type="primary" plain>修改</el-button>
              <el-button  v-if="isShowProcessStateData"  @click="showProcessState" type="primary" plain>所处流程状态</el-button>
          </el-col>
          <el-col :span="2" > 
            <el-button  v-if="isShowProcessState" style="float: left;" type="primary">
              流程任务处于：
            </el-button>
          </el-col>
          <el-col :span="14" > 
            <el-button  v-if="isShowProcessState" style="float: left;" type="primary">
              <AsynCurrentTasksColumn
                  v-if="isShowProcessState"
                  :readOnly="true" 
                  :columnRow="{}"
                  :closeFirstTaskCanDeleteBtn="true"
                  :isShowOverflowTooltip="true"
                  :processInstanceId="modelProcessInstanceId"
                  :processInstanceName="modelprocessInstanceName"
                  :isShowTaskRound="true"
                />
            </el-button>
          </el-col>
        </el-row>
        <div  v-if="isShowSelectData"  class="field-link-dynamicTable">
          <DynamicTable
              :tableColumns="selectTableColumns"
              :tableData="selectTableData"
              :fieldsList="fieldsList"
              :subformFieldsList="subformFieldsList"
          />
        </div>
         <el-dialog
            title="设置查询条件"
            append-to-body
            custom-class="field-item-link-pop-search"
            top="4vh"
            :visible.sync="isShowSearchConditon">
            <SearchCondition  v-if="isShowSearchConditon" :key="conditionLoaderKey" ref="searchConditon" :conditionFields="conditionFields"  @chooseSearchConditon="chooseSearchConditon"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowSearchConditon = false">取 消</el-button>
                <el-button @click="resetSearchConditon">重置</el-button>
                <el-button type="primary" @click="chooseSearchConditon">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog class="popAddModelDetail" width="80%" top="1vh" :fullscreen="true" append-to-body :visible.sync="isShowModelDetail" @close="hideDialog">
            <LinkModelDetail
                ref="addFormData"
                :isShowForm="true"
                :hideRetListBtn = "true"
                :formInfo="formInfo"
                @modelComplete="handleModelDataAdd"
            />
        </el-dialog>

        <el-dialog 
            width="95%"
            top="1vh"
            class="popEditModelDetail"
            :fullscreen=true
            :visible.sync="active"
            append-to-body
            @close="hideEditDialog">
              <ModelDetail
                v-if="isShowEditModelDetail"
                :isShowForm="isShowForm"
                ref="modelInstance"
                :isRead="isRead" 
                :formInfo="formInfo"
                @modelComplete="handleModelComplete"
                @setIsShowForm="setIsShowForm"
              />
        </el-dialog>
<!-- 
        <el-dialog
            title="所在流程详情"
            top="1vh"
            append-to-body
            :visible.sync="isShowProcessState"
            @close="isShowProcessState=false"
            >
            <AsynCurrentTasksColumn
                v-if="isShowProcessState"
                :readOnly="true"
                :isShowOverflowTooltip="true"
                :processInstanceId="modelProcessInstanceId"
                :processInstanceName="modelprocessInstanceName"
                :isShowTaskRound="true"
              />
            <span slot="footer" class="dialog-footer">
              <el-button @click="isShowProcessState=false">关闭</el-button>
          </span>
      </el-dialog> -->
    </div>
</template>

<script>
    import { isEmpty, cloneDeep } from 'lodash';
    import { getFormLeftTree, getLastProcessTaskFormData, getTableColumnsByFormId, getFormAuthByModelId, getModelFormInstanceById, getModeInstanceProcessDetail, getFieldListByMainFormFiedId,
        getFormColumnsByFormId, saveAppModelForm, getModelFormById, getCurrentUserInfo, getModelFormReportList, getFormFieldListByIds, getFormConfig, getModelFormInstanceByIdToLink } from '@/data-model';
    import SearchCondition from '@/components/SearchCondition';
    import AsynCurrentTasksColumn from '@/pages/process/MyProcess/AsynCurrentTasksColumn';
    import ModelDetail from '@/pages/business/BusinessApplication/ModelDetail';
    import { objectKeyIsEmpty } from '@/utils/grocer';
    import { mapGetters } from 'vuex';
    export default {
        components: {
            SearchCondition,
            AsynCurrentTasksColumn,
            LinkModelDetail: ModelDetail
        },
        data () {
            return {
                loadTimer: '',
                formInfo: {},
                isShowModelDetail: false,
                currentUser: {},
                processInstanceId: '',
                isShowProcessData: false,
                isShowSearchConditon: false,
                isRefreshCondition: false,
                conditionFields: [],
                tableHeight: '60vh',
                selectTableColumns: [],
                selectTableData: [],
                // fieldsList: [],
                tableColumns: [],
                subformTableColumns: [],
                subformFieldsList: [],
                tableData: [],
                isShowLink: false,
                isSubform: false, // 是否包含子表单
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                searchParams: {
                    modelId: '',
                    name: '',
                    selectedFields: '',
                    searchCondition: []
                },
                fieldModelMap: new Map(),
                defaultConditonsMap: new Map(), // 默认设置关联数据的过滤条件map
                searchCondition: [],
                isShowEditModelDetail: false,
                active: false,
                isShowForm: false,
                formBtnAuth: {// 表单按钮权限
                    isShowView: true, // 查看
                    isShowAdd: false, // 新增
                    isShowEdit: true, // 修改
                    isShowDelete: false, // 删除
                    isShowImport: false, // 导入
                    isShowExport: false, // 导出
                    isShowSyn: false// 同步流程数据
                },
                isShowEditData: false, // 能否修改关联数据
                isShowProcessState: false,
                modelProcessInstanceId: '', // 关联表单对应业务流程id
                modelprocessInstanceName: '', // 关联表单对应业务流程名称
                isShowProcessStateData: false,
                conditionLoaderKey: false,
                treeData: [],
                searchTreeData: [],
                selectNodeId: 0,
                searchConditionExt: [],
                searchFieldList: [],
                searchCacheList: [],
                idSearchExpandedArr: [],
                isCollapseForInit: true,
                hiddenPage:false,
                autoHeight:false
            };
        },
        props: {
            field: {
                type: Object,
                required: true
            },
            formData: {
                type: Object,
                required: true
            },
            isRead: {
                type: Boolean,
                default: false
            },
            taskInstance: {
                type: Object
            },
            processInstance: {
                type: Object
            },
            processModelFormsObj: {
                type: Array
            },
            relationMapObj: {// 同一个表单内某个字段关联其它字段显示的信息
                type: Object
            },
            fieldsList: {
                type: Array
            },
            formConfig: {// 主表单的表单信息
                type: Object
            },
            colSpan: {
                type: Number
            },
            linkFieldCache: {
                type: Map,
                default: new Map()
            }
            // isShowProcessStateData: {
            //     type: Boolean,
            //     default: true
            // }
        },
        computed: {
            modelId () {
                return this.field.options.config.form.modelId;
            },
            formId () {
                return this.field.options.config.form.formId;
            },
            formFields () {
                return this.field.options.config.form.selectFormFields;
            },
            selectFormFields () {
                return this.tableColumns.filter(item => {
                    return this.formFields.indexOf(item.id) !== -1;
                });
            },
            isShowSelectData () {
                return !isEmpty(this.selectTableData);
            },
            ...mapGetters([
                'userInfo'
            ])
        },
        created () {
            this._initPage();
            if (this.userInfo) {
                this.currentUser = cloneDeep(this.userInfo);
            } else {
                this._getCurrentUserInfo();
            }
            // 国融底稿审核单里关联报告字段显示流程信息
            if (this.formConfig && this.formConfig.id === '5336afd4e31c42eb9b81f6bcc53cda51' && this.formId === '36229f63851e4f819379512d924e351d') {
                this.isShowProcessStateData = true;
            }
            // 先注释掉一出来就自动带出
            // let ext2 = this.field.options.ext2;
            // if (ext2) {
            //     let extObj = JSON.parse(ext2);
            //     if (extObj.automaticRecode) {
            //         this.getTableFirstData();
            //     }
            // }
        },
        methods: {
            async _initPage () {
                if (this.field.ext1 && this.searchParams.searchCondition.length === 0) { // 默认筛选值
                    let obj = JSON.parse(this.field.ext1);
                    this.defaultConditonsMap = new Map();
                    for (let key in obj) {
                        obj[key]['modelId'] = this.modelId;
                        // obj[key]['operateType'] = 1;
                        this.searchParams.searchCondition.push(obj[key]);
                        this.defaultConditonsMap.set(obj[key].id, obj[key]);
                    }
                    this.searchCondition = this.searchParams.searchCondition;
                }
    
                // 国融的合同表单的关联框架合同字段，硬编码过滤出合同类型是主合同的合同begin
                if (this.field.id === '7abddcef62424e4b99145cfa7080e42c') { // 国融合同表单的【关联框架合同】字段
                    let relateFormId = this.field.options.config.form.formId; // 关联字段的关联表单id
                    if (relateFormId && relateFormId === 'b81cbd9fa972415ebb00d3e40e1f5522') { // 国融的【合同表单】
                        // const { fieldsList } = await getFormConfig(relateFormId);
                        let formData = await getFormConfig(relateFormId);
                        if (formData) {
                            let fieldsList = formData.fieldsList;
                            if (fieldsList && fieldsList.length > 0) {
                                for (let k = 0; k < fieldsList.length; k++) {
                                    let field = fieldsList[k];
                                    if (field.id === '98ebfc0abbe143ab8bc2f873a8469fca') { // 合同类型：主合同
                                        field.conditionValue = '6D0C2460';
                                        field.conditionValueView = '主合同';
                                        field.operateType = 1; // 包含
                                        this.searchParams.searchCondition.push(field);
                                        this.defaultConditonsMap.set(field.id, field);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    this.searchCondition = this.searchParams.searchCondition;
                }
                // 国融的合同表单的关联框架合同字段，硬编码过滤出合同类型是主合同的合同

                await this.setLinkLimitData();
                this._setDefaultItem();
                this.matchProcessFieldData();
                this._initFieldMap();
                // 国融环境硬编码处理，TODO:任务中的业务承接表的关联表业务承接评价表（6844e44265354776a22cf3ea00909350），修改关联的业务承接评价表
                if (this.taskInstance && this.formId === '6844e44265354776a22cf3ea00909350') {
                    // 业务承接表 任务中 还未发起审批，或者是发起审批后被驳回审批状态是3时可以修改关联的业务承接评价表
                    if (!this.formData.hasOwnProperty('approvalStatus') || (this.formData.hasOwnProperty('approvalStatus') && this.formData.approvalStatus === '3')) {
                        this.isShowEditData = true;
                    }
                }
                //   中兴华咨硬编码处理:TODO
                if (this.taskInstance && this.taskInstance.taskDefinitionKey === 'sid-5BABD2EE-7F35-4179-BCAE-DB9B2756AAC4' && this.formConfig.id === '95f9c1c05b10499ea3f64cf386f8fc63' && this.field.id === 'ec44e85e0f15498d99164e12b1cddf70') {
                    // 1.报告归档前数据确认sid-5BABD2EE-7F35-4179-BCAE-DB9B2756AAC4  报告审核信息(房地产)(95f9c1c05b10499ea3f64cf386f8fc63),关联项目ec44e85e0f15498d99164e12b1cddf70
                    this.isShowEditData = true;
                } else if (this.taskInstance && this.taskInstance.taskDefinitionKey === 'sid-A43BAE18-7B74-4909-9839-7BB768AD29C4' && this.formConfig.id === 'e226234e239449e09de1e72c0411ba2f' && this.field.id === '4dfd37cd73c041b493ca8084f0197c7c') {
                    // 2.报告归档前数据确认sid-5BABD2EE-7F35-4179-BCAE-DB9B2756AAC4  资产评估报告(e226234e239449e09de1e72c0411ba2f),所属项目4dfd37cd73c041b493ca8084f0197c7c
                    this.isShowEditData = true;
                }
            },
            async _getTreeData (formId) {
                this.searchTreeData = [];
                this.searchFieldList = [];
                let result = await getFormLeftTree({formId: formId});
                if (result && result.treeData && result.treeData.length > 0) {
                    this.isCollapseForInit = true;
                    this.searchTreeData.push(result.treeData[0]);
                    this.defaultField = result.formFieldList[0];
                    this.searchFieldList = result.formFieldList;
                    this.searchCacheList = result.treeData;
                } else {
                    this.isCollapseForInit = false;
                }
                // if (result && result.formConditionFields) { // 搜索条件
                //     let defaultSearchField = JSON.parse(result.formConditionFields);
                //     this.$refs.formListChild.eachSearchField(defaultSearchField);
                //     this.defaultSearchField = defaultSearchField;
                // } else {
                //     let defaultSearchField = [];
                //     if (this.$refs.formListChild) {
                //         this.$refs.formListChild.eachSearchField(defaultSearchField);
                //     }
                // }
            },
            handleTreeNode (data, node, tree) {
                this.searchConditionExt = [];
                if (!data.root) {
                    let condition = {};
                    if (this.defaultField.type === 'department' || this.defaultField.type === 'businessTree' || this.defaultField.type === 'dictionary') {
                        condition = {
                            id: this.defaultField.id,
                            formId: this.formId,
                            modelId: this.modelId,
                            type: this.defaultField.type,
                            operateType: 2,
                            conditionValue: data.id,
                            conditionValueView: data.label
                        };
                    } else {
                        condition = {
                            id: this.defaultField.id,
                            formId: this.formId,
                            modelId: this.modelId,
                            type: this.defaultField.type,
                            operateType: 2,
                            conditionValue: data.key
                        };
                    }
                    this.searchConditionExt.push(condition);
                }
                // this.selectedModel.resetPage = true;
                // this.selectedModel.leftTreeMode = true;
                // this.selectedModel.root = data.root;
                // this.renderModelFormList(this.selectedModel);
                this.getModuleData();
            },
            async expandLeftTree () {
            // 初始化默认展开到第二级
                if (this.searchTreeData && this.searchTreeData.length > 0) {
                    this.idSearchExpandedArr = [];
                    // this.idExpandedArr.push(this.treeData[0].id);
                    this.idSearchExpandedArr.push(this.searchTreeData[0].key);
                }
            },
            handleCommand (command) {
            // console.log(command);
            // console.log(this.searchCacheList);
                this.searchTreeData = [];
                this.searchFieldList.find(item => {
                    if (item.id === command) {
                        this.defaultField = item;
                    }
                });
                let obj = this.searchCacheList.find(item => item.key === command);
                if (obj) {
                    this.searchTreeData.push(obj);
                    this.expandLeftTree();
                }
            },
            async setLinkLimitData () {
                if (this.field.options.ext2) { // 子表单的值进行约束，例如只能查看自己作为项目成员参与的项目列表
                    let json = JSON.parse(this.field.options.ext2);
                    if (json.limitData === true && json.limitFieldDataArray && json.limitFieldDataArray.length > 0) {
                        let relateFormId = this.field.options.config.form.formId; // 关联字段的关联表单id
                        let formData = await getFormConfig(relateFormId);
                        if (formData) {
                            let fieldsList = formData.fieldsList;
                            if (fieldsList && fieldsList.length > 0) {
                                let conditonsMap = new Map();
                                for (let i = 0; i < json.limitFieldDataArray.length; i++) {
                                    let limitField = json.limitFieldDataArray[i];
                                    if (limitField.subFormFieldId) {
                                        let linkPropFieldId = limitField.linkPropFieldId;// 子表单字段
                                        let subFormFieldId = limitField.subFormFieldId;
                                        conditonsMap.set(linkPropFieldId, linkPropFieldId + ',' + subFormFieldId);
                                    }
                                }
                                for (let k = 0; k < fieldsList.length; k++) {
                                    let curfield = fieldsList[k];
                                    if (curfield.type === 'subform' && conditonsMap.has(curfield.id)) {
                                        let targetStr = conditonsMap.get(curfield.id);
                                        curfield.filterMainFieldId = targetStr.split(',')[0];
                                        curfield.filterSubField = targetStr.split(',')[1];
                                        this.searchParams.searchCondition.push(curfield);
                                    }
                                }
                            }
                        }
                    }
                }
            },
            async editModuleData () {
                let loading;
                try {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let dataId = this.selectTableData[0].id;
                    this.formInfo = await getModelFormInstanceById(dataId);
                    let row = this.selectTableData[0];
                    if (this.formInfo) {
                        this.formInfo.modelName = this.field.name;
                        this.formInfo.currentDataId = dataId;
                        this.formInfo.formObj.canStartApproval = false;
                        this.isShowEditModelDetail = true;
                        this.isShowForm = false;
                        this.isRead = false;
                        // row.isCanEdit = this.getEditAuth();
                        row.isCanEdit = true;
                        setTimeout(() => { // 调用子组件的方法
                            this.$refs.modelInstance.loadFormData(this.formInfo, this.formBtnAuth, row, false);
                        }, 0);
                    }
                    this.active = true;
                } catch (error) {
                    console.log(error);
                } finally {
                    loading.close();
                }
            },
            getEditAuth () {
                let isEditAuth = false;
                let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                if (currentUserStr) {
                    let currentUserInfo = JSON.parse(currentUserStr);
                    let resources = currentUserInfo.resources;
                    if (resources) {
                        for (let i = 0; i < resources.length; i++) {
                            if (resources[i].resourceUrl === 'ReportFormDataEditBtn') { // 是否可以点击报表进行数据修改
                                isEditAuth = true;
                                break;
                            }
                        }
                    }
                }
                return isEditAuth;
            },
            setIsShowForm (status) {
                this.isShowForm = status;
            },
            async handleModelComplete (model) {
                let data = await saveAppModelForm(this.field.options.config.form.modelId, model);
                if (data) {
                    let formValues = JSON.parse(data.formValues);
                    let params = {};
                    params.row = formValues.values;
                    await this.getTableColumns();
                    await this.handelSelectRow(params, true);
                }
                this.isShowEditModelDetail = false;
                this.active = false;
            },
            hideEditDialog () {
                this.active = false;
                this.isShowEditModelDetail = false;
            },
            async _getCurrentUserInfo () {
                this.currentUser = await getCurrentUserInfo();
            },
            async _initFieldMap () {
                this.fieldModelMap = new Map();
                if (this.fieldsList && Array.isArray(this.fieldsList)) {
                    this.fieldsList.forEach(fieldObj => {
                        if (fieldObj.options.config.hasOwnProperty('form')) {
                            this.fieldModelMap.set(fieldObj.options.config.form.modelId, fieldObj.id);
                        }
                    });
                }
            },
            async _setDefaultItem () {
                if (this.formData[this.field.formField]) {
                    let selectFormFields = this.field.options.config.form.selectFormFields;// 重新查询构造选择显示的列
                    let formId = this.field.options.config.form.formId;// 可以通过formId从redis获取,性能不会耗费太多
                    let dataId = this.formData[this.field.formField].tableData[0].id;
                    let param = {formId: formId, selectFormFields: selectFormFields, dataId: dataId};
                    if (this.linkFieldCache && this.linkFieldCache.get(dataId)) { // 已经请求后端了
                        let tableData = this.linkFieldCache.get(dataId);
                        let clomn = this.linkFieldCache.get(dataId + 'clomn');
                        if (!isEmpty(clomn)) {
                            let cacheFormId = clomn[0].formId;
                            if (cacheFormId !== formId) {
                                console.log("current form:"+formId+"; cache form:"+cacheFormId);
                                console.log("old field Id:"+this.field.formField+"old instance Id:"+cloneDeep(this.formData[this.field.formField + '-link']));
                                this.formData[this.field.formField].tableData[0].id = this.formData[this.field.formField + '-link'];
                                this.selectTableColumns = this.formData[this.field.formField].tableColumns;
                                this.selectTableData = this.formData[this.field.formField].tableData;
                                console.log("new instance Id:"+this.formData[this.field.formField + '-link']);
                                // console.log(this.selectTableData);
                            } else {
                                this.selectTableData = tableData;
                                this.selectTableColumns = clomn;
                            }
                        }
                        // this.selectTableData = tableData;
                        // this.selectTableColumns = clomn;
                    } else {
                        let res = await getFormColumnsByFormId(param);
                        if (res.state === 'success' && res.rtList.length > 0) {
                            this.selectTableColumns = res.rtList;
                            this.selectTableData = res.rtData;
                            this.linkFieldCache.set(dataId, this.selectTableData);
                            this.linkFieldCache.set(dataId + 'clomn', this.selectTableColumns);
                        } else {
                            this.selectTableColumns = this.formData[this.field.formField].tableColumns;
                            this.selectTableData = this.formData[this.field.formField].tableData;
                        }
                        // this.setCacheField(this.field.id);
                        // this.$emit('asynMainFormData', this.selectTableData[0], this.selectTableColumns, this.field.id, true);
                    }
                }
            },
            setCacheField (fieldId) { // 设置缓存字段不被重复发起刷新的逻辑
                let isLoad = false;
                let tempKey = JSON.stringify('linkFieldCache' + fieldId);
                let cacheData = window.sessionStorage.getItem(tempKey);
                if (cacheData) {
                    let resultData = JSON.parse(cacheData);
                    if (Date.now() - resultData.reqTime > resultData.expired) { // 过期重置
                        window.sessionStorage.removeItem(tempKey);
                        isLoad = true;
                    }
                } else {
                    isLoad = true;
                }
                if (isLoad) {
                    let cacheObj = {
                        isLoad: true,
                        reqTime: Date.now(),
                        expired: 60 * 1000 // 60秒超时时间
                    };
                    let cacheDataStr = JSON.stringify(cacheObj);
                    window.sessionStorage.setItem(tempKey, cacheDataStr);
                    this.$emit('asynMainFormData', this.selectTableData[0], this.selectTableColumns, fieldId, true);
                }
            },
            async matchProcessFieldData () { // 进行同一个流程内关联表单数据自动赋值处理
                let formValMap = new Map();
                let modelInstanceIdsObj = {};
                if (this.processModelFormsObj && Array.isArray(this.processModelFormsObj)) {
                    this.processModelFormsObj.forEach(taskForm => {
                        let objModelFormInstance = this._getTemporaryFormInstance(taskForm);
                        if (objModelFormInstance) {
                            objModelFormInstance.forEach(form => {
                                formValMap.set(form.formId, form);
                            });
                        }
                        if (taskForm.hasOwnProperty('modelInstanceIds')) {
                            let modelInstanceIds = taskForm.modelInstanceIds;
                            let tempModelInstanceIdsObj = JSON.parse(modelInstanceIds);
                            modelInstanceIdsObj = Object.assign(modelInstanceIdsObj, tempModelInstanceIdsObj);
                        }
                    });
                }
                if (formValMap.has(this.formId)) {
                    await this.getTableColumns();
                    // if (modelInstanceIdsObj && modelInstanceIdsObj.hasOwnProperty(this.formId)) {
                    //     let pkId = modelInstanceIdsObj[this.formId];
                    //     // 注释掉，否则会出现审批流表单被替换成已删除的任务表单的情况
                    //     // formValMap.get(this.formId).values.id = pkId;
                    // }
                    let recurseSetRelationDataMap = new Map();
                    // if (!isEmpty(this.formData[this.field.formField])) {
                    if (!this.formData[this.field.formField] && this.field.formId !== this.formId) { // edit by hezhen 20240104 同一个表单引用自己作为关联数据时不能自动加载自己的数据
                        this.selectTableData = [formValMap.get(this.formId).values];
                        this.selectTableColumns = this.selectFormFields;
                        this.setFormFieldData();
                        // 递归赋值
                        recurseSetRelationDataMap.set(this.field.id, formValMap.get(this.formId).values);
                        let repeatSetMap = new Map();// 用来记录重复刷新的关联字段，假如已经赋值过了，就不再赋值了
                        let refLinkCasheDataMap = new Map();// 用来记录已经从后台查过数据的关联数据字段的最新数据
                        await this.recurseSetRelationField(formValMap.get(this.formId).values, recurseSetRelationDataMap, repeatSetMap, refLinkCasheDataMap);
                        // 关联映射
                        let allFormFieldList = await getFieldListByMainFormFiedId(this.field.id);
                        await this.asynMainFormData(formValMap.get(this.formId).values, allFormFieldList, this.field.id);

                        this.$emit('loadLinkData', recurseSetRelationDataMap);
                    }
                    // console.log(recurseSetRelationDataMap);

                    // 智能更新级联显示字段
                    // for (let [key, value] of recurseSetRelationDataMap.entries()) {
                    //     // let allFormFieldList = await getFieldListByMainFormFiedId(key);
                    //     let linkDataId = value.id;
                    //     // console.log(linkDataId);
                    //     // 为了数据准确，需要重新查询数据，重置value（解决底稿审核是否通过，无法关联显示的bug）
                    //     // 从主表中获取关联字段的值，改为直接从应用表单获取最新的数据
                    //     let linkDataInfo = await getModelFormInstanceById(linkDataId);
                    //     if (linkDataInfo && linkDataInfo.formObj) {
                    //         let allFormFieldList = linkDataInfo.formObj.structure[0].fieldsList;
                    //         let linkDataValue = JSON.parse(linkDataInfo.formObj.instance);
                    //         value = linkDataValue.values;
                    //         if (allFormFieldList) {
                    //             this.$emit('asynMainFormData', value, allFormFieldList, key);
                    //         }
                    //     }
                    // }
                    // ------------------------- edit by hezhen 20210929 改造for循环  start-------------------
    
                    if (!isEmpty(recurseSetRelationDataMap)) {
                        let relationDataKeyArr = [];
                        let relationDataValArr = [];
                        for (let [key, value] of recurseSetRelationDataMap.entries()) {
                            relationDataKeyArr.push(key);
                            relationDataValArr.push(value);
                        }
                        for (let i = 0; i < relationDataValArr.length; i++) {
                            let key = relationDataKeyArr[i];
                            let value = relationDataValArr[i];
                            if (value) {
                                let linkDataId = value.id;
                                // 为了数据准确，需要重新查询数据，重置value（解决底稿审核是否通过，无法关联显示的bug）
                                // 从主表中获取关联字段的值，改为直接从应用表单获取最新的数据
                                let param = {instanceId: linkDataId, needFieldList: true};
                                let res = await getModelFormInstanceByIdToLink(param);
                                if (res && res.state === 'success') {
                                    let formValues = res.data;
                                    let formObj = JSON.parse(formValues);
                                    value = formObj.values;
                                    if (res.fieldList) {
                                    // this.$emit('asynMainFormData', value, allFormFieldList, key);
                                        await this.asynMainFormData(value, res.fieldList, key);
                                    }
                                }
                                // let linkDataInfo = await getModelFormInstanceById(linkDataId);
                                // if (linkDataInfo && linkDataInfo.formObj) {
                                //     let allFormFieldList = linkDataInfo.formObj.structure[0].fieldsList;
                                //     console.log(allFormFieldList);
                                //     let linkDataValue = JSON.parse(linkDataInfo.formObj.instance);
                                //     value = linkDataValue.values;
                                //     if (allFormFieldList) {
                                //     // this.$emit('asynMainFormData', value, allFormFieldList, key);
                                //         await this.asynMainFormData(value, allFormFieldList, key);
                                //     }
                                // }

                                // let res = await getModelFormInstanceByIdToLink(linkDataId);
                                // if (res && res.state === 'success') {
                                //     let formValues = res.data;
                                //     let formObj = JSON.parse(formValues);
                                //     sourceData = formObj.values;
                                // }
                            }
                        }
                    }
                    // ------------------------- edit by hezhen 20210929 改造for循环  end-------------------

                    // let keys = '';
                    // for (let [key, value] of recurseSetRelationDataMap.entries()) {
                    //     if (isEmpty(keys)) {
                    //         keys = key;
                    //     } else {
                    //         keys = keys + ',' + key;
                    //     }
                    // }
                    // let formFieldMap = await getFieldListMapByMainFormFiedIds(keys);
                    // // console.log(formFieldMap);
                    // for (let [key, value] of recurseSetRelationDataMap.entries()) {
                    //     let allFormFieldList = formFieldMap[key];
                    //     // console.log(allFormFieldList);
                    //     if (allFormFieldList) {
                    //         this.$emit('asynMainFormData', value, allFormFieldList, key,false);
                    //     }
                    // }
                }
            },
            _getTemporaryFormInstance (sourceForms) {
                let temporaryFormData;
                if (sourceForms && sourceForms.instance) {
                    try {
                        let strTemporaryData = sourceForms.instance;
                        let objTemporaryData = JSON.parse(strTemporaryData);
                        temporaryFormData = objTemporaryData;
                    } catch (error) {
                        console.error('解析任务表单数据异常：', error);
                    }
                }
                return temporaryFormData;
            },
            setEditData (form) {
                this.field.options.config.form = form;
                if (!this.formData[this.field.formField]) {
                    this.selectTableData = [];
                    this.selectTableColumns = [];
                }
                this._setDefaultItem();
            },
            queryFormData ({currentPage}) {
                this.page.currentPage = currentPage;
                this.getModuleData(this.page.pageSize);
            },
            queryFormDataByPageSize ({pageSize}) {
                this.page.pageSize = pageSize;
                this.getModuleData(pageSize);
            },
            async getTableColumns () {
                try {
                    let param = {
                        currentPage: this.page.currentPage,
                        pageSize: this.page.pageSize,
                        modelId: this.modelId,
                        formId: this.formId,
                        isRelationSearch: true,
                        searchCondition: this.searchParams.searchCondition
                    };
                    let formData = await getTableColumnsByFormId(param);
                    this.tableColumns = formData.otherData.tableColumns;
                } catch (error) {
                    console.error('获取关联字段表结构异常');
                }
            },
            async getTableFirstData (pageSize) {
                // this.isSubform = false;
                // 任务表单内选择关联数据，默认从前3000条数据中进行筛选。
                if (this.isShowProcessData) { // 通过流程实例id进行查询，主子流程内的数据
                    this.page.pageSize = 3000;
                    this.processInstanceId = this.taskInstance != null ? this.taskInstance.processInstanceId : '';
                } else if (!pageSize) {
                    this.page.pageSize = (!isEmpty(this.searchFieldList) && this.searchFieldList.length > 0) ? 50 : 10;
                    this.processInstanceId = '';
                }
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await this.setDefaultCondition();
                // ========================中泽报销明细子表单的所属项目字段-项目立项表begin=====================================
                // if (this.formConfig.id === '2c14fd8486d8465989592d68f114df11' && this.formId === '02619f9d003843d2a9046c263c04a51c') { // 项目立项表
                //     const { fieldsList } = await getFormConfig(this.formId);
                //     if (fieldsList && fieldsList.length > 0) {
                //         for (let k = 0; k < fieldsList.length; k++) {
                //             let field = fieldsList[k];
                //             if (field.id === 'b97aaa90fe0d48b58ecf958789aae863') { // 【项目成员】字段
                //                 field.conditionValue = '2f78ea346f8f4c6a88aa80efac5ad57f:' + this.currentUser.userId;
                //                 field.conditionValueView = '2f78ea346f8f4c6a88aa80efac5ad57f:' + this.currentUser.trueName; // 【项目成员】子表单字段的【人员姓名】字段ID：当前登录人ID
                //                 field.operateType = 2; // 等于
                //                 this.searchParams.searchCondition.push(field);
                //                 break;
                //             }
                //         }
                //     }
                // }
                // ========================中泽报销明细子表单的所属项目字段-项目立项表end=======================================
                let newSearchConditionExt = [];
                if (!isEmpty(this.searchConditionExt) && this.searchConditionExt.length > 0) {
                    let searchCondition = this.searchParams.searchCondition.concat(this.searchConditionExt);
                    newSearchConditionExt = cloneDeep(searchCondition);
                    this.page.pageSize = pageSize || 10;
                }
                for (let i = 0; i < this.searchParams.searchCondition.length; i++) {
                    let defaultCondition = this.searchParams.searchCondition[i];
                    if (defaultCondition.operateType === 7) { // 从表单字段值取值搜索
                        let searchvalue = this.formData[defaultCondition.valueFieldId];
                        let cur = this.fieldsList.find(element => element.id === defaultCondition.valueFieldId);
                        let searchvalueView = '';
                        if (cur.type === 'category' || cur.type === 'select') {
                            searchvalueView = this.formData[defaultCondition.valueFieldId + '-view'];
                            let options = defaultCondition.options.config.options;
                            for (let i = 0; i < options.length; i++) {
                                let item = options[i];
                                if (item.title === searchvalueView) {
                                    searchvalue = item.value;
                                }
                            }
                        }
                        if (searchvalue) {
                            defaultCondition.conditionValue = searchvalue;
                            defaultCondition.conditionValueView = searchvalueView;
                            defaultCondition.operateType = 1;
                        }
                    }
                }
                // 处理关联字段值的搜索
                let formData = await getModelFormReportList({
                    currentPage: this.page.currentPage,
                    pageSize: 1,
                    modelId: this.modelId,
                    formId: this.formId,
                    isRelationSearch: true,
                    isFromFieldItemLink: true, // 是否进行关联字段的表单数据查询
                    processInstanceId: this.processInstanceId,
                    searchCondition: !isEmpty(newSearchConditionExt) ? newSearchConditionExt : this.searchParams.searchCondition
                });
                if (formData.data) {
                    let tableDatas = [];
                    formData.data.forEach(item => {
                        let jsonObj = JSON.parse(item);
                        tableDatas.push(jsonObj);
                    });
                    // this.page = {
                    //     currentPage: formData.currentPage,
                    //     pageSize: formData.pageSize,
                    //     totalPageNum: formData.totalPageNum
                    // };
                    this.tableData = tableDatas;
                    // if (tableDatas.length > 0) {
                    //     let param = {row: tableDatas[0]};
                    //     this.handelSelectRow(param);
                    // }
                    loading.close();
                    // this.loadTimer = new Date().getTime();
                }
                if (formData.otherData) {
                    this.tableColumns = formData.otherData.tableColumns;
                    this.subformTableColumns = formData.otherData.subformTableColumns;
                    this.subformFieldsList = formData.otherData.fieldsList;
                }

                // this.isShowLink = true;
                setTimeout(() => { // 调用子组件的方法
                    if (this.$refs.dynamicTable) {
                        this.$refs.dynamicTable.setMergeSpanArr(this.tableData);
                    }
                }, 0);
                this.isSubform = this.getIfSubform(formData.otherData.tableColumns);
                if (this.formId && isEmpty(this.searchFieldList)) {
                    await this._getTreeData(this.formId).then(val => {
                    // 初始化默认展开到第二级
                        this.expandLeftTree();
                        this.loadTimer = new Date().getTime();
                    });
                }
                if (this.field.options.config.form.selectTableHeaderFields) { // 配置了关联列表模型显示表头
                    let cacheTableColumns = [];
                    for (let i = 0; i < this.tableColumns.length; i++) {
                        let cur = this.tableColumns[i];
                        if (this.field.options.config.form.selectTableHeaderFields.indexOf(cur.id) !== -1) {
                            cacheTableColumns.push(cur);
                        }
                    }
                    this.tableColumns = cacheTableColumns;
                }
                if (this.tableData.length > 0) {
                    let param = {row: this.tableData[0]};
                    this.handelSelectRow(param);
                }
            },
            async getModuleData (pageSize) {
                this.isSubform = false;
                // 任务表单内选择关联数据，默认从前3000条数据中进行筛选。
                if (this.isShowProcessData) { // 通过流程实例id进行查询，主子流程内的数据
                    this.page.pageSize = 3000;
                    this.processInstanceId = this.taskInstance != null ? this.taskInstance.processInstanceId : '';
                } else if (!pageSize) {
                    this.page.pageSize = (!isEmpty(this.searchFieldList) && this.searchFieldList.length > 0) ? 50 : 10;
                    this.processInstanceId = '';
                }
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await this.setDefaultCondition();
                let newSearchConditionExt = [];
                if (!isEmpty(this.searchConditionExt) && this.searchConditionExt.length > 0) {
                    let searchCondition = this.searchParams.searchCondition.concat(this.searchConditionExt);
                    newSearchConditionExt = cloneDeep(searchCondition);
                    this.page.pageSize = pageSize || 10;
                }
                for (let i = 0; i < this.searchParams.searchCondition.length; i++) {
                    let defaultCondition = this.searchParams.searchCondition[i];
                    if (defaultCondition.operateType === 7 || defaultCondition.cacheOperateType === 0) { // 从表单字段值取值搜索
                        let searchvalue = this.formData[defaultCondition];
                        let cur = this.fieldsList.find(element => element.id === defaultCondition.valueFieldId);
                        if (cur) {
                            let searchvalueView = '';
                            if (cur.type === 'category' || cur.type === 'select' || cur.type === 'file' || cur.type === 'process' || cur.type === 'address' ||
                        cur.type === 'cascader') {
                                searchvalueView = this.formData[defaultCondition.valueFieldId + '-view'];
                                if (cur.type === 'category' || cur.type === 'select') {
                                    let options = defaultCondition.options.config.options;
                                    for (let i = 0; i < options.length; i++) {
                                        let item = options[i];
                                        if (item.title === searchvalueView) {
                                            searchvalue = item.value;
                                        }
                                    }
                                } else {
                                    searchvalue = this.formData[defaultCondition.valueFieldId + '-view'];
                                }
                            }else if(cur.type === 'link'){
                                searchvalue = this.formData[defaultCondition.valueFieldId + '-link'];
                            } else if (cur.type === 'dictionary' || cur.type === 'businessTree' || cur.type === 'department' || cur.type === 'position') {
                                searchvalueView = this.formData[defaultCondition.valueFieldId + '-tree'];
                                searchvalue = this.formData[defaultCondition.valueFieldId + '-tree'];
                            } else if (cur.type === 'user') {
                                searchvalueView = this.formData[defaultCondition.valueFieldId + '-user'];
                                searchvalue = this.formData[defaultCondition.valueFieldId + '-user'];
                            } else {
                                searchvalueView = this.formData[defaultCondition.valueFieldId];
                                searchvalue = this.formData[defaultCondition.valueFieldId];
                            }
                            if (searchvalue) {
                                defaultCondition.conditionValue = searchvalue;
                                defaultCondition.conditionValueView = searchvalueView;
                                defaultCondition.operateType = 1;
                                defaultCondition.cacheOperateType = 0;
                            }
                        }
                    }
                }
                let ext2Obj = JSON.parse(this.field.options.ext2);
                if(ext2Obj.prohibitPaging){
                    this.page.pageSize=3000;
                    this.hiddenPage=true;
                    this.autoHeight=true;
                }
                // 处理关联字段值的搜索
                let formData = await getModelFormReportList({
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize,
                    modelId: this.modelId,
                    formId: this.formId,
                    isRelationSearch: true,
                    isFromFieldItemLink: true, // 是否进行关联字段的表单数据查询
                    processInstanceId: this.processInstanceId,
                    searchCondition: !isEmpty(newSearchConditionExt) ? newSearchConditionExt : this.searchParams.searchCondition
                });
                loading.close();
                if (formData && formData.data) {
                    let tableDatas = [];
                    formData.data.forEach(item => {
                        let jsonObj = JSON.parse(item);
                        tableDatas.push(jsonObj);
                    });
                    this.page.totalPageNum=formData.totalPageNum;
                    this.page.pageSize=10;
                    this.tableData = tableDatas;
                    this.loadTimer = new Date().getTime();
                }
                if (formData && formData.otherData) {
                    this.tableColumns = formData.otherData.tableColumns;
                    this.subformTableColumns = formData.otherData.subformTableColumns;
                    this.subformFieldsList = formData.otherData.fieldsList;
                }

                this.isShowLink = true;
                setTimeout(() => { // 调用子组件的方法
                    if (this.$refs.dynamicTable) {
                        this.$refs.dynamicTable.setMergeSpanArr(this.tableData);
                    }
                }, 0);
                this.isSubform = this.getIfSubform(formData.otherData.tableColumns);
                if (this.formId && isEmpty(this.searchFieldList)) {
                    await this._getTreeData(this.formId).then(val => {
                    // 初始化默认展开到第二级
                        this.expandLeftTree();
                        this.loadTimer = new Date().getTime();
                    });
                }
                if (this.field.options.config.form.selectTableHeaderFields) { // 配置了关联列表模型显示表头
                    let cacheTableColumns = [];
                    for (let i = 0; i < this.tableColumns.length; i++) {
                        let cur = this.tableColumns[i];
                        if (this.field.options.config.form.selectTableHeaderFields.indexOf(cur.id) !== -1) {
                            cacheTableColumns.push(cur);
                        }
                    }
                    this.tableColumns = cacheTableColumns;
                }
            },
            async setDefaultCondition () {
                if (this.field.options.ext3 && this.field.options.ext3 === '1' && !isEmpty(this.defaultConditonsMap)) { // 设置过滤条件为固定模式
                    if (this.searchParams.searchCondition && Array.isArray(this.searchParams.searchCondition)) {
                        let defaultConditons = [];
                        this.searchParams.searchCondition.forEach(conditiontObj => {
                            if (this.defaultConditonsMap.has(conditiontObj.id)) {
                                let defaultCondition = this.defaultConditonsMap.get(conditiontObj.id);
                                if (defaultCondition && defaultCondition.conditionValue) {
                                    defaultConditons.push(defaultCondition);
                                } else {
                                    defaultConditons.push(conditiontObj);
                                }
                            } else {
                                defaultConditons.push(conditiontObj);
                            }
                        });
                        if (!isEmpty(defaultConditons)) {
                            this.searchParams.searchCondition = defaultConditons;
                        }
                    }
                }
                if (this.field.options.ext2) {
                    let def = JSON.parse(this.field.options.ext2);
                    if (def.linkConfig) {
                        let linkConfig = JSON.parse(def.linkConfig);
                        if (linkConfig.linkConfigState) { // 需要过滤数据
                            this.searchParams.searchCondition = [];
                            let key = linkConfig.id + '-link';
                            let value = this.formData[key];
                            if (!value) { // 如果此处没有取到值，可能存在加载顺序，谷休眠半秒继续再取一次，再取不到就让用户手动选择
                                await this.sleep(500);
                                if (this.formData[0]) {
                                    value = this.formData[0].values[key];
                                }
                            }
                            let curObj = JSON.parse(linkConfig.linkFieldObj);
                            curObj.conditionValue = value;
                            if (linkConfig.type !== 'link') {
                                curObj.operateType = 2;
                            } else {
                                curObj.operateType = 7;
                            }
                            this.searchParams.searchCondition.push(curObj);
                        }
                    }
                }
                await this.setLinkLimitData();
            },
            sleep (ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },
            async clearModuleData () {
                this.selectTableData = [];
                this.selectTableColumns = [];
                this.setFormFieldData();
                // 清空时把级联字段也同时清空
                let allFormFieldList = await getFieldListByMainFormFiedId(this.field.id);
                if (allFormFieldList) {
                    // this.$emit('asynMainFormData', value, allFormFieldList, key);
                    await this.asynMainFormData(null, allFormFieldList, this.field.id);
                }
            },
            async viewModuleData () {
                let loading;
                // if (this.isRead) {
                //     this.messageTip('不支持查看详情数据', 'warning');
                //     return;
                // }
                try {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let formData = await getFormAuthByModelId({ modelId: this.modelId });
                    if (formData && formData.modelAuth) {
                        let dataId = this.selectTableData[0].id;
                        var url = '/linkFormDetail/' + this.modelId + '/' + this.formId + '/' + dataId;
                        if (window.location.href.indexOf('#/') > -1) {
                            // 本地访问路径
                            url = '#' + url;
                        } else {
                            url = '/bpm' + url;
                        }
                        window.open(url, '_blank');
                    } else {
                        this.messageTip('您没有配置该表单模型权限，无法查看详情数据', 'warning');
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    loading.close();
                }
            },
            getIfSubform (tableColumns) {
                let isSubform = false;
                for (var i = 0; i < tableColumns.length; i++) {
                    // 判断当前元素与上一个元素是否相同
                    if (tableColumns[i].subcolumn) {
                        isSubform = true;
                        break;
                    }
                }
                return isSubform;
            },
            setLinkTableData (selectTableColumns, sourceFormObj, originalColumns) { // 增加关联字段显示字段的冗余字段数据
                let linkData = {};
                if (sourceFormObj) {
                    linkData['id'] = sourceFormObj.id;
                    if (selectTableColumns && selectTableColumns.length > 0) {
                        let selectcolumns;
                        if (originalColumns) {
                            selectcolumns = cloneDeep(originalColumns);
                        } else {
                            selectcolumns = cloneDeep(selectTableColumns);
                        }
                        // let selectcolumns = cloneDeep(selectTableColumns);
                        // console.log(selectcolumns);
                        selectcolumns.forEach(item => {
                            if (item.type === 'dictionary' || item.type === 'businessTree' || item.type === 'department') {
                                // -tree
                                linkData[item.id] = sourceFormObj[item.id];
                                linkData[item.id + '-tree'] = sourceFormObj[item.id + '-tree'];
                            } else if (item.type === 'user') {
                                // -user
                                linkData[item.id] = sourceFormObj[item.id];
                                linkData[item.id + '-user'] = sourceFormObj[item.id + '-user'];
                            } else if (item.type === 'category' || item.type === 'select' || item.type === 'file' || item.type === 'process' || item.type === 'address' || item.type === 'cascader' || item.type === 'role') {
                                // -view
                                linkData[item.id] = sourceFormObj[item.id];
                                linkData[item.id + '-view'] = sourceFormObj[item.id + '-view'];
                            } else if (item.type === 'calculation' || item.type === 'number' || item.type === 'text' || item.type === 'serialNumber' || item.type === 'date') {
                                linkData[item.id] = sourceFormObj[item.id];
                            } else if (item.type === 'link') {
                                linkData[item.id + '-view'] = sourceFormObj[item.id + '-view'];
                            } else if (item.type === 'subform') {
                                linkData[item.id] = sourceFormObj[item.id];
                            }
                        });
                    }
                }
                return linkData;
            },
            setFormFieldData () {
                let linkData = this.setLinkTableData(this.selectTableColumns, this.selectTableData[0]);
                this.formData[this.field.formField] = {
                    modelId: this.modelId,
                    tableColumns: this.selectTableColumns,
                    tableData: this.selectTableData.length === 1 ? [linkData] : [this.selectTableData[0]]
                };
                if (this.selectTableData.length === 1) { // 单选
                    this.formData[this.field.formField + '-link'] = this.selectTableData[0].id; // 针对关联字段进行关联表主键赋值
                    if (this.selectTableColumns[0].type === 'subform' && !isEmpty(this.selectTableColumns[0].subColumns)) {
                        let key = this.translateKey(this.selectTableColumns[0].subColumns[0].type, this.selectTableColumns[0].subColumns[0].id);
                        this.formData[this.field.formField + '-view'] = this.selectTableData[0][key];
                    } else {
                        let key = this.translateKey(this.selectTableColumns[0].type, this.selectTableColumns[0].id);
                        this.formData[this.field.formField + '-view'] = this.selectTableData[0][key]; // 针对关联字段进行关联表主键赋值
                    }
                } else if (this.selectTableData.length === 0) {
                    this.formData[this.field.formField + '-link'] = ''; // 针对关联字段进行关联表主键赋值
                    this.formData[this.field.formField + '-view'] = ''; // 针对关联字段进行关联表主键赋值
                }
                if (this.selectTableColumns.length === 0) {
                    this.formData[this.field.formField] = '';
                }
            },
            async handelSelectRow (params, isRefresh) { // TODO
                const tempLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let selData = cloneDeep(params.row);
                this.selectTableData = [selData];// 复制当前选中数据
                if (this.field.options.ext2) {
                    let json = JSON.parse(this.field.options.ext2);
                    if (json.limitData == true && json.limitFieldDataArray && json.limitFieldDataArray.length > 0) {
                        for (let i = 0; i < json.limitFieldDataArray.length; i++) {
                            let cur = json.limitFieldDataArray[i];
                            let curKey = cur.linkPropFieldId;
                            let curValue = cur.selectLimitFieldData;
                            for (let j = 0; j < this.selectTableData.length; j++) {
                                let rowData = this.selectTableData[j];
                                let rowValue = rowData[curKey];
                                if (curValue === rowValue) {
                                    this.$message.error('所选数据存在【' + cur.linkPropFieldObj.name + '】限制不可被选中,有问题请联系系统管理员');
                                    tempLoading.close();
                                    return;
                                }
                            }
                        }
                    }
                }
                this.selectTableColumns = this.selectFormFields;
                this.setFormFieldData();
                this.isShowLink = false;
                let recurseSetRelationDataMap = new Map();
                if (this.formConfig && this.formConfig.ext2 !== '1') {
                    recurseSetRelationDataMap.set(this.field.id, params.row);
                    let repeatSetMap = new Map();// 用来记录重复刷新的关联字段，假如已经赋值过了，就不再赋值了
                    repeatSetMap.set(this.field.id, this.field.id);
                    let refLinkCasheDataMap = new Map();// 用来记录已经从后台查过数据的关联数据字段的最新数据
                    await this.recurseSetRelationField(params.row, recurseSetRelationDataMap, repeatSetMap, refLinkCasheDataMap);
                    this.$emit('loadLinkData', recurseSetRelationDataMap);
                }
                // 主子合同流水号修改逻辑begin
                // console.log(this.formConfig);
                if (this.formConfig && this.formConfig.id === 'b81cbd9fa972415ebb00d3e40e1f5522' && this.field.id === '7abddcef62424e4b99145cfa7080e42c') { // 国融【合同信息表】
                    if (this.formData.id && this.fieldsList && this.fieldsList.length > 0) {
                        for (let fieldIndex = 0; fieldIndex < this.fieldsList.length; fieldIndex++) {
                            let field = this.fieldsList[fieldIndex];
                            if (field.type === 'serialNumber' && field.options.ext3 === '2' && field.options.config.options.length > 0) {
                                if (field.id === 'c6219b4ce1e94150b0f0a00ab63ecf83') { // 合同信息表的合同编号字段
                                    await this.reSetSerialNumber(field, params.row);
                                }
                            }
                        }
                    }
                }
                // 主子合同流水号修改逻辑end

                // 更新主表字段
                // console.log(this.formData);
                 let formData = await getFormConfig(this.formId);
                 let tableColumns =formData.fieldsList;
                //  this.$emit('asynMainFormData', params.row, this.tableColumns, this.field.id, isRefresh);
                 this.$emit('asynMainFormData', params.row, tableColumns, this.field.id, isRefresh);
                // let i = 0;
                // let isLast = false;
                // 智能更新级联显示字段
                // for (let [key, value] of recurseSetRelationDataMap.entries()) {
                //     let allFormFieldList = await getFieldListByMainFormFiedId(key);
                //     i = i + 1;
                //     if (i === recurseSetRelationDataMap.size) {
                //         isLast = true;
                //     }
                //     if (allFormFieldList) {
                //         // this.$emit('asynMainFormData', value, allFormFieldList, key);
                //         this.asynMainFormData(value, allFormFieldList, key);
                //     }
                // }
                // ------------------------- edit by hezhen 20210929 改造for循环  start-------------------
                if (!isEmpty(recurseSetRelationDataMap)) {
                    let relationDataKeyArr = [];
                    let relationDataValArr = [];
                    for (let [key, value] of recurseSetRelationDataMap.entries()) {
                        relationDataKeyArr.push(key);
                        relationDataValArr.push(value);
                    }
                    for (let i = 0; i < relationDataValArr.length; i++) {
                        let key = relationDataKeyArr[i];
                        let value = relationDataValArr[i];
                        if (value) {
                            let allFormFieldList = await getFieldListByMainFormFiedId(key);
                            if (allFormFieldList) {
                                // this.$emit('asynMainFormData', value, allFormFieldList, key);
                                await this.asynMainFormData(value, allFormFieldList, key);
                            }
                        }
                    }
                }
                tempLoading.close();
                // this.renderLinkField();
                // ------------------------- edit by hezhen 20210929 改造for循环  end-------------------
            },
            async renderLinkField () {
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let ext2Obj = JSON.parse(ext2);
                    if (ext2Obj.automaticRecodeRefField) { // 配置了级联带出
                        let automaticRecodeFields = ext2Obj.automaticRecodeFields;
                        let automaticRecodeFieldsArray = automaticRecodeFields.split(',');
                        for (let i = 0; i < automaticRecodeFieldsArray.length; i++) {
                            let automaticRecodeFieldsItem = automaticRecodeFieldsArray[i];
                            let fieldObj = this.fieldsList.find(element => element.id === automaticRecodeFieldsItem);
                            if (fieldObj) {
                                await this.getTableFirstData(fieldObj, this.fieldsList);
                            }
                        }
                    }
                }
            },
            async reSetSerialNumber (field, linkObjTableData) {
                let currentSerialNumber = this.formData[field.formField]; // 当前字段流水号
                let upSerialNumber = linkObjTableData['c6219b4ce1e94150b0f0a00ab63ecf83']; // 国融合同表单框架合同号
                if (currentSerialNumber) {
                    let arr = currentSerialNumber.split('-');
                    if (arr.length >= 1) {
                        if (upSerialNumber) {
                            if (arr.length === 1) {
                                this.formData[field.formField] = upSerialNumber + '-' + currentSerialNumber;
                            } else if (arr.length > 1) {
                                this.formData[field.formField] = upSerialNumber + '-' + arr[1];
                            }
                        }
                    }
                }
            },
            // ========================================关联映射逻辑begin=======================================
            // currentlinkFieldId主表关联字段；selectTableColumns关联表的所有字段；sourceData关联表数据
            async asynMainFormData (sourceData, selectTableColumns, currentlinkFieldId) {
                // console.log('关联字段:' + currentlinkFieldId);
                // console.log(sourceData);
                if (sourceData != null) {
                    let linkDataId = sourceData.id;
                    // 为了数据准确，需要重新查询数据，重置value,效率上有些慢，后续优化
                    let param = {instanceId: linkDataId, needFieldList: false};
                    let res = await getModelFormInstanceByIdToLink(param);
                    if (res && res.state === 'success' && res && res.data) {
                        let formValues = res.data;
                        let formObj = JSON.parse(formValues);
                        sourceData = formObj.values;
                    }
                }
                if (selectTableColumns && Array.isArray(selectTableColumns)) {
                    let targetFormFieldlist = this.fieldsList;
                    selectTableColumns.forEach(fieldObj => {
                        let sourceFieldLabel = fieldObj.label;
                        targetFormFieldlist.forEach(element => {
                            // console.log('关联配置的关联字段ID:' + element.options.synLinkField);
                            if (element.options.synLinkField && element.options.synLinkField === currentlinkFieldId) {
                                if (element.options.synLinkFormFieldId) {
                                    if (element.options.synLinkFormFieldId === fieldObj.id) {
                                        this.updSynLinkFieldData(element, fieldObj, sourceData);
                                    }
                                } else {
                                    if (sourceFieldLabel === element.name && element.type === 'text') {
                                        this.updSynLinkFieldData(element, fieldObj, sourceData);
                                    }
                                }
                            }
                        });
                    });
                }
                // this.loadTimerField = new Date().getTime();
            },
            // 修改配置了关联映射的字段值
            // sourceData关联字段的数据，element需要映射的主表字段，fieldObj关联表单的字段
            updSynLinkFieldData (element, fieldObj, sourceData) {
                let type = fieldObj.type;
                let sourceValueKey = ''; // 对应userId等唯一性值
                let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
                let sourceDepartmentValueKey = ''; // 对应部门等唯一性值
                let can = false; // 是否支持级联显示
                if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                    // -tree
                    can = true;
                    if (sourceData) {
                        sourceDepartmentValueKey = sourceData[fieldObj.id];
                        sourceValue = sourceData[fieldObj.id + '-tree'];
                    }
                } else if (type === 'user') {
                    // -user
                    can = true;
                    if (sourceData) {
                        sourceValueKey = sourceData[fieldObj.id];
                        sourceValue = sourceData[fieldObj.id + '-user'];
                    }
                } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                    // -view
                    can = true;
                    if (sourceData) {
                        sourceValue = sourceData[fieldObj.id + '-view'];
                    }
                    if (element.options.synLinkFormField && (element.options.synLinkFormField.type && element.options.synLinkFormField.type === 'category' && element.options.synLinkFormField.options.config.type === 'multi')) {
                        let cacheValue = sourceData[fieldObj.id];
                        let cacheValueArray = [];
                        for (let i = 0; i < fieldObj.options.config.options.length; i++) {
                            let cur = fieldObj.options.config.options[i];
                            if (cacheValue.indexOf(cur.value) !== -1) {
                                cacheValueArray.push(cur.title);
                            }
                        }
                        sourceValue = cacheValueArray.join(',');
                    }
                } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date') {
                    can = true;
                    if (sourceData) {
                        sourceValue = sourceData[fieldObj.id];
                    }
                } else if (type === 'link') {
                    can = true;
                    if (sourceData) {
                        sourceValue = sourceData[fieldObj.id + '-view'];
                    }
                } else if (type === 'subform') {
                    can = true;
                    if (sourceData) {
                        sourceValue = sourceData[fieldObj.id];
                    }
                }
                if (can) {
                    if (element.type === 'text') {
                        // this.formData[0].values[element.id] = sourceValue;
                        // this.formData[0].values[element.id + '-view'] = '';
                        this.formData[element.id] = sourceValue;
                        this.formData[element.id + '-view'] = '';
                    } else if (element.type === 'date') {
                        this.formData[element.id] = sourceValue;
                        if (!isEmpty(sourceValue)) {
                            this.formData[element.id] = sourceValue;
                        } else {
                            this.formData[element.id] = '';
                        }
                    } else if (element.type === 'number' || element.type === 'calculation') {
                        if (!isEmpty(sourceValue)) {
                            this.formData[element.id] = sourceValue;
                            this.formData[element.id + '-view'] = '';
                        } else {
                            this.formData[element.id] = '';
                            this.formData[element.id + '-view'] = '';
                        }
                        // this.refreshViewField();
                    } else if (element.type === 'user') {
                        // console.log(element);
                        // fieldId-user: trueName ，fieldId: userId
                        // console.log(sourceValue);
                        // console.log(sourceValueKey);
                        if (!isEmpty(sourceValue)) {
                            this.formData[element.id] = sourceValueKey;
                            this.formData[element.id + '-user'] = sourceValue;
                        } else {
                            this.formData[element.id] = '';
                            this.formData[element.id + '-user'] = '';
                        }
                    } else if (element.type === 'department') {
                        if (!isEmpty(sourceValue)) {
                            this.formData[element.id] = sourceDepartmentValueKey;
                            this.formData[element.id + '-tree'] = sourceValue;
                        } else {
                            this.formData[element.id] = '';
                            this.formData[element.id + '-tree'] = '';
                        }
                    } else if (element.type === 'select') {
                        // console.log(element);
                        if (!isEmpty(sourceValue)) {
                            // 下拉选项值
                            let targetFieldValue = {};
                            let targetFieldOptions = element.options.config.options;
                            for (let i = 0; i < targetFieldOptions.length; i++) {
                                let optionItem = targetFieldOptions[i];
                                if (optionItem.title === sourceValue) {
                                    targetFieldValue = optionItem;
                                    break;
                                }
                            }
                            if (targetFieldValue) {
                                // this.formData[0].values[element.id] = targetFieldValue.value;
                                // this.formData[0].values[element.id + '-view'] = targetFieldValue.title;
                                this.formData[element.id] = targetFieldValue.value;
                                this.formData[element.id + '-view'] = targetFieldValue.title;
                            }
                        } else {
                            // this.formData[0].values[element.id] = '';
                            // this.formData[0].values[element.id + '-view'] = '';
                            this.formData[element.id] = '';
                            this.formData[element.id + '-view'] = '';
                        }
                    } else if (element.type === 'subform') {
                        let sourceSubColumns = fieldObj.subColumns;
                        if (isEmpty(sourceSubColumns)) { // 智能关联，需要这样取值
                            sourceSubColumns = fieldObj.options.fieldList;
                            for (let k = 0; k < sourceSubColumns.length; k++) {
                                sourceSubColumns[k].label = sourceSubColumns[k].name;
                            }
                        }
                        let taragetSubColumns = element.options.fieldList;
                        let newValue = [];
                        // console.log(sourceSubColumns);
                        // console.log(taragetSubColumns);
                        // console.log(element);
                        // console.log(sourceValue);
                        if (!isEmpty(sourceValue)) {
                            for (let i = 0; i < sourceValue.length; i++) {
                                let sourceItemValue = sourceValue[i];
                                let targetItemValue = {};
                                // console.log(sourceItemValue);
                                for (let j = 0; j < taragetSubColumns.length; j++) { // 寻找同名的字段，然后获取其值付给目标字段
                                    let targetColumn = taragetSubColumns[j];
                                    for (let k = 0; k < sourceSubColumns.length; k++) {
                                        let sourceColumn = sourceSubColumns[k];
                                        if (targetColumn.label === sourceColumn.label) {
                                            if (sourceColumn.type === 'dictionary' || sourceColumn.type === 'businessTree' || sourceColumn.type === 'department') {
                                                // -tree
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-tree'];
                                            } else if (sourceColumn.type === 'user') {
                                                // -user
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-user'];
                                            } else if (sourceColumn.type === 'category' || sourceColumn.type === 'select' || sourceColumn.type === 'file' || sourceColumn.type === 'process' || sourceColumn.type === 'address' || sourceColumn.type === 'cascader' || sourceColumn.type === 'role') {
                                                // -view
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-view'];
                                            } else if (sourceColumn.type === 'calculation' || sourceColumn.type === 'number' || sourceColumn.type === 'text' || sourceColumn.type === 'serialNumber' || sourceColumn.type === 'date') {
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id];
                                            }
                                            break;
                                        }
                                    }
                                }
                                if (!isEmpty(targetItemValue)) {
                                    newValue.push(targetItemValue);
                                }
                            }
                            // console.log(newValue);
                            // this.formData[0].values[element.id] = newValue;
                            this.formData[element.id] = newValue;
                        } else {
                            // this.formData[0].values[element.id] = '';
                            this.formData[element.id] = '';
                        }
                    }
                    if (!sourceData) {
                        this.$emit('refreshViewField');
                    } else {
                        this.cascadeControlViewField(element);
                    }
                }
            },
            cascadeControlViewField (element) { // 20230914 edit by hezhen页面一开始初始化后级联处理关联数据带出的字段级联控制其显示字段的逻辑
                let firstInitTaskDetailPage = window.sessionStorage.getItem('firstInitTaskDetailPage');
                if (firstInitTaskDetailPage && element.type === 'select' && !isEmpty(element.options.config.options)) {
                    window.sessionStorage.removeItem('firstInitTaskDetailPage');
                    let selArr = element.options.config.options;
                    let isCascadeSetting = false;
                    for (let i = 0; i < selArr.length; i++) {
                        let selObj = selArr[i];
                        if (selObj.ext3) {
                            isCascadeSetting = true;
                            break;
                        }
                    }
                    if (isCascadeSetting) { // 表示下拉字段有级联显示控制,需要刷新处理
                        let cascedeStr = window.sessionStorage.getItem('fieldItemLinkInitCascedeStr');
                        let cascedeArr = isEmpty(cascedeStr) ? [{id: element.id}] : JSON.parse(cascedeStr);
                        cascedeArr.push({id: element.id});
                        cascedeStr = JSON.stringify(cascedeArr);
                        window.sessionStorage.setItem('fieldItemLinkInitCascedeStr', cascedeStr);
                    }
                }
            },
            // ========================================关联映射逻辑end=======================================
            async recurseSetRelationField (originalObject, recurseSetRelationDataMap, repeatSetMap, refLinkCasheDataMap) { // 递归查找关联的字段
                // 通过for-in循环遍历JSON对象
                let originalObjectKeyArr = [];
                let originalObjectValArr = [];
                for (let key in originalObject) {
                    originalObjectKeyArr.push(key);
                    originalObjectValArr.push(originalObject[key]);
                }
                // for (var key in originalObject) {
                // let tempObj = originalObject[key];
                for (let i = 0; i < originalObjectValArr.length; i++) {
                    let tempObj = originalObjectValArr[i];
                    let values = {};
                    if (tempObj instanceof Object && tempObj.hasOwnProperty('tableData')) { // 对象类型
                        if (this.fieldModelMap.has(tempObj.modelId)) {
                            let fieldId = this.fieldModelMap.get(tempObj.modelId);
                            // this.formData[fieldId] = tempObj;
                            if (!repeatSetMap.has(fieldId)) {
                                let res = null;
                                // 国融三级报告流程的报告签发任务节点，关联表单是报告，则需要重新获取流程内的最新报告表来关联
                                if (tempObj.modelId === '3be755c9bfbe479289c69e2ff60cfbc7' && this.taskInstance && this.taskInstance.processServiceId === '3e6c67ee38984e8495d0a1b1371825e9' && this.taskInstance.taskDefinitionKey === 'sid-A30691F6-8242-4A48-AFEC-40F5131B5608') { // 报告表
                                    if (!refLinkCasheDataMap.has(tempObj.tableData[0].id)) {
                                        res = await getLastProcessTaskFormData({processInstanceId: this.taskInstance.processInstanceId, modelId: tempObj.modelId});
                                        if (!res) {
                                            continue;
                                        }
                                        refLinkCasheDataMap.set(tempObj.tableData[0].id, res);
                                        // console.log(res);
                                    } else {
                                        res = refLinkCasheDataMap.get(tempObj.tableData[0].id);
                                        // console.log(res);
                                    }
                                } else {
                                    if (!refLinkCasheDataMap.has(tempObj.tableData[0].id)) {
                                        let reqCnt = 0;
                                        while (reqCnt < 3) { // TODO:用于同一个页面3个以下表单时请求处理，超过3个表单有可能取不到数据，一般都是3个表单以内
                                            // res = await getModelFormInstanceById(tempObj.tableData[0].id);
                                            let param = {instanceId: tempObj.tableData[0].id, needFieldList: false};
                                            res = await getModelFormInstanceByIdToLink(param);
                                            if (!res) { // 请求3次
                                                reqCnt++;
                                            } else {
                                                reqCnt = 3;
                                            }
                                        }
                                        if (!res) {
                                            continue;
                                        }
                                        refLinkCasheDataMap.set(tempObj.tableData[0].id, res);
                                        // console.log(res);
                                    } else {
                                        res = refLinkCasheDataMap.get(tempObj.tableData[0].id);
                                    }
                                }
    
                                if (res && res.state === 'success' && res.data) {
                                    let formValues = res.data;
                                    let formObj = JSON.parse(formValues);
                                    values = formObj.values;
                                } else {
                                    if (res && res.formObj && res.formObj.instance) {
                                        let instance = res.formObj.instance;
                                        let obj = JSON.parse(instance);
                                        values = obj.values;
                                    }
                                }
                                // if (!this.formData[fieldId]) {
                                //     continue;
                                // }
                                let cur = {};
                                cur.modelId = tempObj.modelId;
                                let originalColumns = cloneDeep(this.formData[fieldId].tableColumns);
                                if (originalColumns) {
                                    cur.tableColumns = originalColumns;
                                } else {
                                    cur.tableColumns = tempObj.tableColumns;
                                }
                                // edit by hezhen 20210928 修改关联字段结构体, 去掉级联数据冗余字段
                                let linkData = this.setLinkTableData(cur.tableColumns, values, originalColumns);
    
                                // let tableData = {id: values.id};
                                // console.log(linkData);
                                cur.tableData = [linkData];
                                // cur.tableData = [values];
    
                                // tempObj.tableData[0] = values;
                                this.formData[fieldId] = cur;
                                // console.log(this.formData);
                                if (this.formData[fieldId].tableData && this.formData[fieldId].tableData.length > 0) {
                                    if (this.formConfig.ext2 !== '1') {
                                        this.formData[fieldId + '-link'] = this.formData[fieldId].tableData[0].id;
                                        if (this.formData[fieldId].tableColumns && this.formData[fieldId].tableColumns.length > 0) {
                                            let key = this.translateKey(this.formData[fieldId].tableColumns[0].type, this.formData[fieldId].tableColumns[0].id);
                                            this.formData[fieldId + '-view'] = this.formData[fieldId].tableData[0][key];
                                        }
                                        if (!recurseSetRelationDataMap.has(fieldId)) {
                                            // 关联映射
                                            let allFormFieldList = await getFieldListByMainFormFiedId(fieldId);
                                            await this.asynMainFormData(this.formData[fieldId].tableData[0], allFormFieldList, fieldId);
                                            recurseSetRelationDataMap.set(fieldId, this.formData[fieldId].tableData[0]);
                                        }
                                    }
                                }
                                repeatSetMap.set(fieldId, fieldId);
                            }
                        } else {
                            values = tempObj.tableData[0];
                        }
                        await this.recurseSetRelationField(values, recurseSetRelationDataMap, repeatSetMap, refLinkCasheDataMap);
                    }
                }
            },
            // async recurseSetRelationField (originalObject, recurseSetRelationDataMap, repeatSetMap, refLinkCasheDataMap) { // 递归查找关联的字段
            //     // 通过for-in循环遍历JSON对象
            //     for (var key in originalObject) {
            //         let tempObj = originalObject[key];
            //         if (tempObj instanceof Object && tempObj.hasOwnProperty('tableData')) { // 对象类型
            //             if (this.fieldModelMap.has(tempObj.modelId)) {
            //                 let fieldId = this.fieldModelMap.get(tempObj.modelId);
            //                 this.formData[fieldId] = tempObj;
            //                 if (this.formData[fieldId].tableData.length > 0) {
            //                     if (this.formConfig.ext2 !== '1') {
            //                         this.formData[fieldId + '-link'] = this.formData[fieldId].tableData[0].id;
            //                         // console.log(this.formData[fieldId]);
            //                         if (this.formData[fieldId].tableColumns && this.formData[fieldId].tableColumns.length > 0) {
            //                             let key = this.translateKey(this.formData[fieldId].tableColumns[0].type, this.formData[fieldId].tableColumns[0].id);
            //                             this.formData[fieldId + '-view'] = this.formData[fieldId].tableData[0][key];
            //                         }
            //                         if (!recurseSetRelationDataMap.has(fieldId)) {
            //                             // 关联映射
            //                             let allFormFieldList = await getFieldListByMainFormFiedId(fieldId);
            //                             this.asynMainFormData(this.formData[fieldId].tableData[0], allFormFieldList, fieldId);

            //                             recurseSetRelationDataMap.set(fieldId, this.formData[fieldId].tableData[0]);
            //                         }
            //                     }
            //                 }
            //             }
            //             this.recurseSetRelationField(tempObj.tableData[0], recurseSetRelationDataMap);
            //         }
            //     }
            // },
            translateKey (type, key) {
                let transKey = key;
                if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                    transKey = transKey + '-tree';
                } else if (type === 'user') {
                    transKey = transKey + '-user';
                } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'link') {
                    transKey = transKey + '-view';
                }
                return transKey;
            },
            handleAllLinkData () {
                this.getModuleData();
            },
            async handleFilterCondition () {
                this.isShowSearchConditon = false;
                if (!this.isRefreshCondition) {
                    let columns = cloneDeep(this.tableColumns);
                    let idArr = [];
                    columns.forEach(item => {
                        idArr.push(item.id);
                    });
                    this.conditionFields = await getFormFieldListByIds(idArr.join(','));
                    this.isRefreshCondition = true;
                }
                this.isShowSearchConditon = true;
            },
            async chooseSearchConditon () {
                this.isShowSearchConditon = false;
                let searchCondition = this.$refs.searchConditon.getSearchCondition();
                // 关联字段查询用-view,否则有些查不到
                if (searchCondition && searchCondition.length > 0) {
                    for (let i = 0; i < searchCondition.length; i++) {
                        let cur = searchCondition[i];
                        if (cur.type === 'link') {
                            cur.searchFieldId = cur.id + '-view';
                        }
                    }
                }
                this.page.currentPage = 1; // 分页重置为了1
                this.searchParams.searchCondition = searchCondition;
                this.getModuleData();
            },
            async resetSearchConditon () {
                this.conditionFields.length = 0;
                let columns = cloneDeep(this.tableColumns);
                let idArr = [];
                columns.forEach(item => {
                    idArr.push(item.id);
                });
                this.conditionFields = await getFormFieldListByIds(idArr.join(','));
                this.conditionLoaderKey = new Date().getTime();
            },
            hideDialog () {
                // console.log(this.searchParams.searchCondition);
                this.searchParams.searchCondition = this.searchCondition;
                this.isShowLink = false;
                this.isShowModelDetail = false;
            },
            async addNewLinkData () {
                // // 校验是否有权限录入数据
                // let formData = await getAppAssignList({
                //     currentPage: 1,
                //     pageSize: 500,
                //     modelId: this.modelId,
                //     mode: 1 // 已授权
                // });
                // let userList = formData.data;
                // let isCan = false;
                // userList.forEach(row => {
                //     if (row.userId === this.currentUser.userId) {
                //         isCan = true;
                //     }
                // });
                // if (!isCan) {
                //     this.messageTip('您没有配置该表单模型权限，无法新增数据', 'warning');
                //     return false;
                // }

                let loading;
                try {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let formData = await getFormAuthByModelId({ modelId: this.modelId });
                    if (formData && formData.modelAuth) {
                        // 切换到表单录入
                        this.formInfo = await getModelFormById(this.modelId);
                        this.formInfo.modelName = this.formInfo.formObj.structure[0].modelName;
                        this.formInfo.appName = this.formInfo.formObj.structure[0].appName;
                        this.formInfo.remarks = this.formInfo.formObj.structure[0].remarks;
                        this.formInfo.modelType = this.formInfo.formObj.structure[0].modelType;
                        this.isShowModelDetail = true;
                        setTimeout(() => {
                            this.$refs.addFormData.loadFormData(this.formInfo);
                        }, 0);
                    } else {
                        this.messageTip('您没有配置该表单模型权限，无法新增数据', 'warning');
                        return false;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    loading.close();
                }
            },
            async handleModelDataAdd (model) {
                if (objectKeyIsEmpty(model.forms[0].values, model.forms[0].attributes)) {
                    this.$confirm(`表单数据为空，数据将不会保存！`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then((res) => {
                        this.isShowModelDetail = false;
                    }).catch(() => {});
                } else {
                    model.modelId = this.modelId;
                    let data = await saveAppModelForm(this.modelId, model);
                    if (data) {
                        this.getModuleData();
                        this.loadTimer = new Date().getTime();
                    }
                    this.isShowModelDetail = false;
                }
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            },
            async showProcessState () {
                if (!this.isShowProcessState) {
                    let loading;
                    try {
                        loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        let formData = await getFormAuthByModelId({ modelId: this.modelId });
                        if (formData.modelAuth) {
                            let dataId = this.selectTableData[0].id;
                            // let modelInfo = await getModelFormInstanceById(dataId);
                            let param = {instanceId: dataId, approvalInstanceId: '', formId: ''};
                            let modelInfo = await getModeInstanceProcessDetail(param);
                            if (modelInfo && modelInfo.businessInstanceId) {
                                this.modelProcessInstanceId = modelInfo.businessInstanceId;
                                this.modelprocessInstanceName = modelInfo.businessInstanceName;
                                this.isShowProcessState = true;
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    } finally {
                        loading.close();
                    }
                } else {
                    this.isShowProcessState = false;
                }
            },
            isShowBtn () {
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let extObj = JSON.parse(ext2);
                    if (extObj.prohibitAdd) {
                        return false;
                    } else {
                        return true;
                    }
                }
            }
        }
    };
</script>

<style lang="less">
    .field-item-link {
      .checkBox-style{
            margin-left:5px;
            .el-checkbox__label{
                padding-left: 5px;
            }
        }
    }
    .field-item-link-pop{
       height: 95vh;
       overflow: auto;
      .form-data-box{
            display: flex;
            .content-tree{
                width: auto;
                display: flex;
                height: 70vh;
                overflow: auto;
                .left-icon{
                    cursor: pointer;
                    width: 20px;
                    height: 24px;
                    text-align: center;
                    padding-top: 2px;
                    padding-right: 10px;
                    position: fixed;
                    margin-left: 185px;
                }
                .el-tree{
                    width: 230px;
                    @media screen and (min-width: 1024px) and (max-width: 1366px) {
                        width: 180px;
                    }
                }
            }
        }
        .el-dialog__body{
            padding: 20px 20px !important;
        }
    }
    .field-link-dynamicTable{
        line-height: 0px;
      }
</style>



// WEBPACK FOOTER //
// src/components/FieldItem/FieldItemLink.vue